module.exports = __webpack_public_path__ + "img/icon4.bd02c1fa.png";